import { render, staticRenderFns } from "./ReferralsView.vue?vue&type=template&id=61bda7c0&scoped=true&"
import script from "./ReferralsView.vue?vue&type=script&lang=js&"
export * from "./ReferralsView.vue?vue&type=script&lang=js&"
import style0 from "./ReferralsView.vue?vue&type=style&index=0&id=61bda7c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bda7c0",
  null
  
)

export default component.exports